'use strict';

function initializeEvents() {

    if ($("#pageBanner").length > 0)
    {
    
        $(window).scroll(function (event) {
    
            let pageBanner = document.getElementById('pageBanner');
            let contentoverlay = document.getElementById('contentoverlay');
            let coverdiscription = document.getElementById('coverdiscription');

            function handleScroll() {

                const scrollPosition = window.scrollY;
                const bannerHeight = pageBanner.offsetHeight;

                // Calculate the percentage scrolled
                const scrollPercentage = (scrollPosition / bannerHeight) * 100;
                    
                if(scrollPercentage > $("#pageBanner").offset().top ) {
                    //contentoverlay.style.height = (scrollPercentage * 4) +'%';
                    contentoverlay.style.height = '216px';
                    contentoverlay.style.maxHeight = '216px';
                    contentoverlay.style.bottom = '0';
                    if(scrollPercentage > 5 ){
                        coverdiscription.style.opacity  = '1';
                        coverdiscription.style.transition  = 'opacity .8s ease-in-out';
                    }
                    }else {
                        contentoverlay.style.height = '0';
                        coverdiscription.style.opacity  = '0';
                        coverdiscription.style.transition  = 'opacity .8s ease-in-out';
                    }
                }
            
                // Initial check in case the banner is already in view on page load
                handleScroll();
            
                // Listen for scroll events
                window.addEventListener('scroll', handleScroll);
        });    
    }
}


const init = function () {
	initializeEvents();
};

export default { init };
